export enum enumBinaCatalogItemType {
  UPDATED_AND_NOT_SUBJECT_TO_QUOTAS,
  TARIFF_CHANGED,
  SUBJECT_TO_QUOTAS,
  HTS_NO_LONGER_VALID,
}
